import { keys } from '@classic/Foundation/Analytics/AnalyticsDataLayer'
import { trackEvent } from '@classic/Foundation/Analytics/GoogleTagManagerService'

export const trackBetTypeChange = (data: object): void =>
  trackEvent(keys.productSelectionChanged, { data })
